<template>
    <v-card flat class="mb-4 pa-4">
        <v-row dense>
            <v-col cols="12" sm="6" lg="3">
                <v-text-field
                        v-model="localFilters.numero"
                        label="Número da proposta:"
                        placeholder="Digite o número da proposta"
                        clearable
                        hide-details
                        outlined
                        @input="emitFilters"
                />
            </v-col>
            <v-col cols="12" sm="6" lg="3">
                <v-select
                        v-model="localFilters.statusPagamento"
                        :items="statusPagamentoOptions"
                        label="Status do pagamento:"
                        placeholder="Selecione o status do pagamento"
                        clearable
                        hide-details
                        outlined
                        @change="emitFilters"
                />
            </v-col>
            <v-col cols="12" sm="6" lg="3">
                <v-select
                        v-model="localFilters.statusContrato"
                        :items="statusContratoOptions"
                        label="Status do contrato:"
                        placeholder="Selecione o status do contrato"
                        hide-details
                        clearable
                        outlined
                        @change="emitFilters"
                />
            </v-col>
            <v-col cols="12" sm="6" lg="3">
                <v-select
                        v-model="localFilters.formaPagamento"
                        :items="formasPagamentoOptions"
                        label="Forma de pagamento:"
                        placeholder="Selecione a forma de pagamento"
                        hide-details
                        clearable
                        outlined
                        @change="emitFilters"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-btn class="transition ml-3 mt-4" color="secondary" type="reset" @click="resetFiltros">Limpar</v-btn>
        </v-row>
    </v-card>
</template>

<script>
  import { FormasPagamentoDesc, StatusPedidoDesc } from '@/plugins/constants'
  import { StatusBoletoCarrinho } from '@/plugins/multiplasCotasBoletoStatus'
  import { StatusContratoDesc } from '../../../plugins/constants'
  const filtroDefault = {
    numero: '',
    statusPedido: null,
    statusPagamento: null,
    statusContrato: null
  }
  export default {
    name: 'FiltroMultiplaCotas',
    props: {
      value: {
        type: Object,
        default: () => (filtroDefault)
      }
    },
    data () {
      return {
        localFilters: { ...this.value },
        statusPedidoOptions: Object.values(StatusPedidoDesc).sort(),
        statusPagamentoOptions: Object.values(StatusBoletoCarrinho).sort(),
        statusContratoOptions: Object.values(StatusContratoDesc).sort(),
        formasPagamentoOptions: Object.values(FormasPagamentoDesc).sort()
      }
    },
    watch: {
      value (newVal) {
        this.localFilters = { ...newVal }
      }
    },
    methods: {
      emitFilters () {
        this.$emit('input', { ...this.localFilters })
      },
      resetFiltros () {
        this.localFilters = { ...filtroDefault }
        this.emitFilters()
      }
    }
  }
</script>

<style scoped>
.mb-4 {
  margin-bottom: 16px;
}
</style>
